import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { HomeBreakerProps } from './models';
import { Link } from 'react-router-dom';

export default class HomeBreaker extends React.Component<HomeBreakerProps, {}> {


    private assignBackgroundColor = (): string => {
        switch (this.props.backgroundColor) {
            case "primary":
                return process.env.REACT_APP_PRIMARY_COLOR || "#FFF";
            case "secondary":
                return process.env.REACT_APP_SECONDARY_COLOR || "#FFF";
            case "custom":
            default:
                return this.props.backgroundColorCustom || "#FFF";
        }
    }

    private assignMainTextColor = (): string => {
        switch (this.props.mainTextColor) {
            case "primary":
                return process.env.REACT_APP_PRIMARY_COLOR || "#FFF";
            case "secondary":
                return process.env.REACT_APP_SECONDARY_COLOR || "#FFF";
            case "custom":
            default:
                return this.props.mainTextColorCustom || "#FFF";
        }
    }

    private assignBottomTextColor = (): string => {
        switch (this.props.bottomTextColor) {
            case "primary":
                return process.env.REACT_APP_PRIMARY_COLOR || "#FFF";
            case "secondary":
                return process.env.REACT_APP_SECONDARY_COLOR || "#FFF";
            case "custom":
            default:
                return this.props.bottomTextColorCustom || "#FFF";
        }
    }

    render() {
        return (<Box
            className={"h-title h-explore-title"}
            textAlign={"center"}
            sx={{
                mb: 10, mt: 10, p: 10,
                backgroundColor: this.assignBackgroundColor()
            }}>
            <Typography variant={"h1"}
                sx={{
                    color: this.assignMainTextColor(),
                    fontWeight: "bold",
                    letterSpacing: "1px",
                    mb: "5px"
                }}>
                {this.props.mainText}
            </Typography>
            <Typography variant={"h4"}
                sx={{
                    color: this.assignBottomTextColor(),
                    mb: "10px"
                }}>
                {this.props.bottomText}
            </Typography>
            {(this.props.buttons) && this.props.buttons.map((element, index) => (
                <Link to={element.route || "/"} style={{ textDecoration: "none" }}>
                    <Button variant={"contained"}
                        color={"secondary"}
                        size={"large"}>
                        {element.text}
                    </Button>
                </Link>
            ))}
        </Box >);
    }
}